import React from 'react';
import { FiExternalLink } from 'react-icons/fi';

import Reveal, { SectionTitle } from './Reveal';
import { EXPERIENCE } from '../data/site';

export default function Experience() {
  return (
    <section className="section" id="experience">
      <SectionTitle
        eyebrow="Where I've worked"
        title="Experience"
        subtitle="Roles where I shipped real products and helped others do the same."
      />

      <div className="tl">
        {EXPERIENCE.map((job, i) => (
          <Reveal
            key={`${job.company}-${job.period}`}
            delay={i * 0.06}
            className={`tl-item${job.current ? ' is-current' : ''}`}
          >
            <article className="glass tl-card">
              <div className="tl-head">
                <h3 className="tl-company">{job.company}</h3>
                <span className="tl-period">{job.period}</span>
              </div>

              <div className="tl-role">{job.role}</div>
              <div className="tl-place">{job.place}</div>

              <ul className="tl-points">
                {job.points.map((p) => (
                  <li key={p}>{p}</li>
                ))}
              </ul>

              {job.tags && (
                <div className="tl-tags">
                  {job.tags.map((t) => (
                    <span key={t} className="tag">
                      {t}
                    </span>
                  ))}
                </div>
              )}

              {job.link && (
                <a
                  className="tl-link"
                  href={job.link.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {job.link.label} <FiExternalLink />
                </a>
              )}
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
